const getInitialState = () => ({
    tables: {},
    tableEntries: {},
    tableColumns: {},

    openRequests: [],
    failedRequests: [],
    updatedAt: 0,
    lastInteractiveConfigId: null,
});

export default {
    getInitialState
};
